import { Avatar, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import React from 'react';
import { Icons } from '../../common/icons/Icons';
import { H, V } from '../../common/Layout';
import { useI18n } from '../../common/i18n/I18n';

export const ProductionOptionRenderer = ({ option, isAIExtractedFlow = false }) => {
    const createOption = option && option.createOption;
    const label = createOption ? `Add ${option.label}` : option.label;

    const searchForText = useI18n('common.search.for');
    const searchAndClearAllText = useI18n('common.clear.and.search.all.without.entity');
    const addText = useI18n('common.add');   

    const isClearAndSearchOption =  option?.label.includes(searchAndClearAllText);
    const isSearchForOption = option?.label.includes(searchForText);

    const subLabel = option?.productionAttributes;
    return (
        <H gap={1}>
            <>
                {!isAIExtractedFlow &&  
                    <Avatar sx={{ bgcolor: grey[500], color: 'white' }}>
                        <Icons.Production />
                    </Avatar>
                }
                
                {isAIExtractedFlow && isSearchForOption &&
                    <Icons.Search />
                }

                {isAIExtractedFlow && !isSearchForOption && !isClearAndSearchOption &&
                    <Icons.AddButton />
                }

                {isAIExtractedFlow && isClearAndSearchOption &&
                    <Icons.Close />
                }
            </>
            <V sx={{ width: '100%' }}>
                <Typography sx={{ fontStyle: createOption ? 'italic' : 'normal' }} variant="subtitle1">
                    {label}
                </Typography>
                <Typography sx={{ fontStyle: createOption ? 'italic' : 'normal' }} variant="subtitle2">
                    {subLabel}
                </Typography>
            </V>
        </H>
    );
};
